import { MouseEvent, RefObject, useEffect, useRef, useState } from 'react';

import Button from '@/components/common/Button';

type Props = {
  inputRef: RefObject<HTMLInputElement | null>;
  onMouseDown?: (e: MouseEvent<HTMLButtonElement>) => void;
};

const Delete = ({ inputRef, onMouseDown }: Props) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isFocused, setIsFocused] = useState(false);
  const isVisible = !!inputRef.current?.value && isFocused;

  const toggleFocus = (e: FocusEvent) => {
    setIsFocused(e.type === 'focus');
  };

  const handleMouseDown = (e: MouseEvent<HTMLButtonElement>) => {
    onMouseDown?.(e);
    inputRef.current?.focus();
  };

  useEffect(() => {
    inputRef.current?.addEventListener('focus', toggleFocus);
    inputRef.current?.addEventListener('blur', toggleFocus);

    return () => {
      inputRef.current?.removeEventListener('focus', toggleFocus);
      inputRef.current?.removeEventListener('blur', toggleFocus);
    };
  }, []);

  return (
    <Button
      ref={buttonRef}
      className="btn_del"
      onMouseDown={handleMouseDown}
      style={{ display: isVisible ? 'block' : 'none' }}
    >
      <span className="ico_wallet ico_del">삭제</span>
    </Button>
  );
};

export default Delete;
